const avatarString = (name: string | null): string => {
  if (!name) return "";

  const parts = name.trim().split(/\s+/); 

  if (parts.length === 1) {
    return parts[0].charAt(0).toUpperCase();
  } else if (parts.length === 2) {
    return (
      parts[0].charAt(0).toUpperCase() + 
      parts[1].charAt(0).toUpperCase()   
    );
  } else {
  
    const firstInitial = parts[0].charAt(0).toUpperCase(); 
    const lastInitial = parts[1].charAt(0).toUpperCase(); 
    return firstInitial + lastInitial;
  }
};

export default avatarString;
